export const getNavigationVersion = () =>
    sessionStorage.getItem("isManageOrgRedirect") ||
    sessionStorage.getItem("hasComeFromDesktop")
        ? "ManageInWeb"
        : "Unified";
